import React from 'react'
import Hero from '../components/Hero';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import Team from '../components/Team';
import Contact from '../components/Contact';
import Testimonials from '../components/Testimonials';
import BlogSection from '../components/BlogSection'
import AboutUsSection from '../components/AboutSection';
import SEOHead from '../components/SEOHead';

const HomePage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Codewave Technologies Limited",
    "alternateName": ["Codewave", "Codewave Kenya"],
    "url": "https://www.codewave.co.ke",
    "description": "Codewave Technologies Limited is a leading ICT company in Kenya providing telecom solutions, bulk SMS services, USSD service provider, SMS gateway, mobile payment solutions, and API integration services for businesses in Nairobi and across Kenya.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.codewave.co.ke/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Codewave Technologies Limited",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.codewave.co.ke/codewave-logo.png"
      }
    }
  };

  return (
    <>
      <SEOHead
        title="Codewave Technologies Limited - Premier ICT & Telecom Solutions in Kenya | Bulk SMS, USSD, API Integration"
        description="Codewave Technologies Limited - Leading ICT company in Kenya. Affordable bulk SMS services, best USSD service provider, SMS gateway for businesses, mobile payment solutions, and enterprise messaging. Trusted telecom company in Nairobi."
        keywords="Codewave, Codewave Technologies Limited, ICT company in Kenya, telecom solutions Kenya, bulk SMS Kenya, USSD service provider Kenya, SMS gateway Kenya, mobile payment solutions Kenya, business communication solutions, API integration services Kenya, bulk SMS service provider, USSD application development, short code services Kenya, IVR solutions Kenya, voice SMS services, enterprise messaging solutions, mobile API services, business SMS marketing, customer engagement platforms, digital communication solutions, affordable bulk SMS services in Kenya, best USSD service provider in Kenya, SMS gateway for businesses in Kenya, API integration for mobile payments, IVR and voice solutions for companies, short code and USSD setup services, telecom API provider in Kenya, business messaging solutions Kenya, ICT services Nairobi, telecom company Nairobi Kenya, bulk SMS Nairobi, USSD services Nairobi, Kenyan ICT solutions provider"
        url="https://www.codewave.co.ke"
        type="website"
        structuredData={structuredData}
      />
      <Hero />
      <AboutUsSection />
      <Services />
      <HowItWorks />
      <Team maxMembers={6} />
      <Testimonials />
      <BlogSection />
      <Contact />
    </>
  )
}

export default HomePage
